module.exports = __webpack_public_path__ + "static/media/logoutIcon_white.47fcf095.svg";